var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from "react";
import { Icon } from "./icon";
import { FlexContainer } from "../grid/flexcontainer";
import { LoadingSpinner } from "../components/loadingspinner";
import { bind } from "decko";
import * as ReactDOM from "react-dom";
import Button from "./button";
import { css, cx } from "emotion";
import { getThemeColorVar } from "../helper/color";
const xlWidgetClass = css({
    label: {
        color: getThemeColorVar("typo", "default"),
        display: "block",
        fontSize: "16px",
        fontWeight: 600,
        lineHeight: "25px",
        marginBottom: "5px",
    },
    "input:focus-within": {
        zIndex: 10000,
    },
});
const xlWidgetViewClass = css({
    label: {
        color: getThemeColorVar("typo", "default"),
        display: "block",
        fontSize: "16px",
        fontWeight: 600,
        lineHeight: "25px",
        whiteSpace: "pre-wrap",
    },
});
const buttonContainerClass = css({
    maxWidth: "0px",
    transition: "max-width .5s",
    marginLeft: "10px",
    "> div": {
        overflow: "hidden",
    },
});
const requiredMarkerClass = css({
    color: getThemeColorVar("negative", "default"),
    fontWeight: 600,
});
const editModeClass = css({
    maxWidth: "100%",
});
export class XlWidget extends React.Component {
    renderInner() {
        throw new Error("abstractMethod not implemented");
    }
    constructor(props, submitRequireControlModifier) {
        super(props);
        this.submitRequireControlModifier = submitRequireControlModifier;
        this.wrapperFlexProps = {
            direction: "row",
            flexWrap: "nowrap",
        };
        this.buttonWrapperFlexProps = {
            direction: "row",
            spaceBetween: "base",
        };
        this.state = {
            editMode: false,
            editValue: props.value,
            validationError: false,
        };
    }
    handleKeyPress(event) {
        switch (event.key) {
            case "Enter":
                if (this.submitRequireControlModifier && !event.ctrlKey) {
                    return;
                }
                if (!this.state.validationError && this.isDirty()) {
                    this.save();
                }
                return;
            case "Escape":
                this.discard();
                return;
        }
    }
    handleOutsideClick(event) {
        try {
            const domNode = ReactDOM.findDOMNode(this);
            if (!this.state.editMode ||
                (event.type === "focus" && event.target === document))
                return;
            if (domNode &&
                domNode.contains &&
                !domNode.contains(event.target)) {
                if (this.isDirty() && !this.state.validationError) {
                    this.save();
                }
                else {
                    this.discard();
                }
            }
        }
        catch (e) {
        }
    }
    componentWillMount() {
        document.addEventListener("click", this.handleOutsideClick.bind(this));
        document.addEventListener("focus", this.handleOutsideClick.bind(this), true);
    }
    componentWillUnmount() {
        document.removeEventListener("click", this.handleOutsideClick.bind(this));
        document.removeEventListener("focus", this.handleOutsideClick.bind(this), true);
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.value != this.props.value ||
            (this.props.saveInProgress && !nextProps.saveInProgress)) {
            this.setState({ editValue: nextProps.value });
        }
    }
    edit() {
        if (!this.state.editMode) {
            this.setState({ editMode: true });
        }
    }
    discard() {
        this.inputWrapper &&
            this.inputWrapper.inputElRef &&
            this.inputWrapper.inputElRef.blur();
        this.setState({
            editMode: false,
            editValue: this.props.value,
            validationError: false,
        });
    }
    editValueUpdate(newValue, valid) {
        this.setState({ editValue: newValue, validationError: !valid });
    }
    renderSaveIndicator() {
        if (this.isDirty() && this.props.saveInProgress) {
            return (React.createElement(FlexContainer, { direction: "row", paddingX: "base", canGrow: false, "md-align": "center" },
                React.createElement(LoadingSpinner, { size: 32 })));
        }
        else {
            return null;
        }
    }
    save() {
        if (!this.state.validationError) {
            this.props.onSave && this.props.onSave(this.state.editValue);
            this.inputWrapper &&
                this.inputWrapper.inputElRef &&
                this.inputWrapper.inputElRef.blur();
            this.setState({ editMode: false });
        }
    }
    currentValue() {
        return this.state.editValue;
    }
    isDirty() {
        return this.state.editValue != this.props.value;
    }
    render() {
        const wrapperClasses = [xlWidgetClass].concat(this.additionalWrapperClasses);
        const buttonContainerClasses = [buttonContainerClass].concat(this.additionalButtonContainerClasses);
        if (this.state.editMode) {
            this.additionalEditModeClass &&
                wrapperClasses.push(this.additionalEditModeClass);
            buttonContainerClasses.push(editModeClass);
            this.additionalButtonContainerEditModeClass &&
                buttonContainerClasses.push(this.additionalButtonContainerEditModeClass);
        }
        if (this.props.viewMode) {
            return (React.createElement("div", { className: cx(xlWidgetViewClass) },
                this.props.label && React.createElement("label", null, this.props.label),
                this.props.viewModeValue
                    ? this.props.viewModeValue
                    : this.props.value));
        }
        return (React.createElement("div", { className: cx(wrapperClasses) },
            this.props.label && (React.createElement("label", null,
                this.props.label,
                this.props.required && (React.createElement("span", { className: cx(requiredMarkerClass) }, " *")))),
            React.createElement(FlexContainer, Object.assign({}, this.wrapperFlexProps),
                React.createElement(FlexContainer, { canShrink: true, spaceBetween: "base", "md-align": "center" },
                    this.isDirty() &&
                        !this.state.editMode &&
                        !this.props.saveInProgress && (React.createElement(Icon, { color: "negative", colorType: "default", name: "error" })),
                    this.renderInner()),
                React.createElement("div", { className: cx(buttonContainerClasses) },
                    React.createElement(FlexContainer, Object.assign({}, this.buttonWrapperFlexProps),
                        React.createElement(Button, { type: "secondary", icon: "check", tabIndex: -1, size: this.props.size === "small" ? "small" : "normal", disabled: !this.state.editMode ||
                                !this.isDirty() ||
                                this.state.validationError, title: "\u23CE", onClick: (e) => {
                                this.save();
                                e.stopPropagation();
                                e.preventDefault();
                                e.currentTarget.blur();
                            } }),
                        React.createElement(Button, { type: "secondary", icon: "clear", tabIndex: -1, size: this.props.size === "small" ? "small" : "normal", disabled: !this.state.editMode, title: "ESC", onClick: (e) => {
                                this.discard();
                                e.stopPropagation();
                                e.preventDefault();
                                e.currentTarget.blur();
                            } }))),
                this.renderSaveIndicator())));
    }
}
__decorate([
    bind,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], XlWidget.prototype, "handleKeyPress", null);
__decorate([
    bind,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], XlWidget.prototype, "handleOutsideClick", null);
__decorate([
    bind,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], XlWidget.prototype, "edit", null);
__decorate([
    bind,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], XlWidget.prototype, "discard", null);
__decorate([
    bind(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Boolean]),
    __metadata("design:returntype", void 0)
], XlWidget.prototype, "editValueUpdate", null);
__decorate([
    bind,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], XlWidget.prototype, "save", null);
__decorate([
    bind,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Object)
], XlWidget.prototype, "currentValue", null);
__decorate([
    bind,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Boolean)
], XlWidget.prototype, "isDirty", null);
//# sourceMappingURL=xlwidget.js.map